// Maximum number of characters for the `designNotes` property on notices
export const DESIGN_NOTES_MAX_CHARS = 255;
